import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';

export type PageSection = {
  label: string;
  value: number | string;
};

type Props = {
  backTo: string;
  title: string;
  sections: PageSection[];
};

const PageNavigation: React.FC<Props> = ({ backTo, title, sections }) => (
  <Box component="header" display="flex" alignItems="center" mx={8}>
    <IconButton component={RouterLink} to={backTo} size="large" edge="start">
      <ArrowBackIcon />
    </IconButton>
    <Typography variant="h2">{title}</Typography>

    <Box display="flex" alignItems="center">
      {sections.map((sec, idx) => (
        <Box key={sec.label} display="flex" alignSelf="stretch">
          {idx > 0 && <Divider orientation="vertical" flexItem />}

          <Stack px={4} direction="row" spacing={4} alignItems="center">
            <Typography variant="body1">{sec.label}</Typography>
            <Typography variant="subtitle1">{sec.value}</Typography>
          </Stack>
        </Box>
      ))}
    </Box>
  </Box>
);

export default PageNavigation;
